import React, {useEffect, useRef} from "react";
import {useTranslation} from "@i18n";
import stl from "./AsideTag.module.css";
import { CDN_LINK } from "@globalConfig";
import {replaceTextWithCurrencySymbols} from "@/_MiniApps/CurrencyFont/CurrencyFontProvider";

function AsideTag({
  isDicountTag,
  name,
  onClick,
  hideDelete,
  isActiveDiscount,
  className,
  iconImage,
  textellipsis=false,
}) {
  const { t } = useTranslation(["web_search"]);
  const nameSpanRef=useRef(null);
    useEffect(() => {
        if (nameSpanRef.current) {
            replaceTextWithCurrencySymbols(name, nameSpanRef.current);
        }
    }, [name]);
  return (
    <>
      <span
          title={name}
        onClick={onClick}
        className={[
          stl.tag,
          isDicountTag ? stl.dicountTag : stl.blueTag,
          isActiveDiscount ? stl.activeDiscount : undefined,
          className ? className : undefined,
          hideDelete ? stl.disabled : "",
        ].join(" ")}>

          <span ref={nameSpanRef} className={textellipsis?"md:overflow-hidden md:text-ellipsis md:max-w-[100px] md:whitespace-nowrap":undefined}>
        {name}
              </span>
        {!hideDelete && (
          <img
            src={iconImage ? iconImage : CDN_LINK + "/assets/images/blueX.svg"}
            alt="Delete"
            aria-label="Delete"
          />
        )}
        {isActiveDiscount && (
          <img
            src={CDN_LINK + "/assets/images/closewhite.svg"}
            alt="Delete"
            width="15px"
            height="15px"
          />
        )}
      </span>
    </>
  );
}

export default AsideTag;
